/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Economic_GroupInputs */

const en_clients_field_economic_group = /** @type {(inputs: Clients_Field_Economic_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economic group`)
};

const pt_br2_clients_field_economic_group = /** @type {(inputs: Clients_Field_Economic_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo econômico`)
};

/**
* | output |
* | --- |
* | "Economic group" |
*
* @param {Clients_Field_Economic_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_economic_group = /** @type {((inputs?: Clients_Field_Economic_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Economic_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_economic_group(inputs)
	return pt_br2_clients_field_economic_group(inputs)
});